// import the new component
import {UsersComponent} from './users.component';
import {UsersRoutingModule} from './users-routing.module';
import {UserComponent} from './components/user/user.component';
import {UserListComponent} from './components/user-list/user-list.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
// import {DialogSharedComponent} from "../../components/dialog-shared/dialog-shared.component";
import {UserDialog} from '../../components/users/user-dialog/user-dialog.component';
import {RegistrationUserDialog} from '../../components/users/registration-user-dialog/registration-user-dialog.component';
import {RuleSortPipe} from '../../components/price-rules/rules-sort.pipe';
import {TranslateModule} from '@ngx-translate/core';
import {UserSettingsComponent} from '../user-settings/user-settings.component';
import {SettingsComponent} from './components/settings/settings.component';
import {SharedModule} from '../shared/shared.module';
import {OrdersComponent} from './components/orders/orders.component';
import {DiscountsComponent} from './components/discounts/discounts.component';
import {CarriersComponent} from './components/carriers/carriers.component';
import {InvoicesComponent} from './components/invoices/invoices.component';
import {NotesComponent} from './components/notes/notes.component';
import {InfoComponent} from './components/info/info.component';
import {MaterialModule} from '../material/material.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
  providers: [],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    // libraries
    MaterialModule,
    TranslateModule.forChild(),
    // custom modules
    UsersRoutingModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [
    UsersComponent,
    UserComponent,
    UserListComponent,
    // DialogSharedComponent,
    // UserDialog,
    RegistrationUserDialog,
    SettingsComponent,
    OrdersComponent,
    DiscountsComponent,
    CarriersComponent,
    InvoicesComponent,
    NotesComponent,
    InfoComponent,
    // DialogOverviewExampleDialog
    //pipes
    // RuleSortPipe
  ],
  exports: [UsersComponent],
  entryComponents: [RegistrationUserDialog]
})

export class UsersModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/users/users.module.ts